module.exports = __webpack_public_path__ + "img/icon-keypad.46481c63.svg";